<template>
    <div>
        <v-alert v-if="error" color="red" elevation="2" border="left" class="mt-4" colored-border>
            <div class="d-block d-sm-flex align-center">
                <div class="flex-grow-1 mb-3 mb-sm-0">{{error.msg}}</div>
                <v-btn v-if="error.action" outlined :to="error.to">{{error.action}}</v-btn>
            </div>
        </v-alert>

        <router-view></router-view>
    </div>
</template>

<script>
const errors = {
    'project not found': {msg: 'The project you requested does not exist.'},
    'application not found': {msg: 'The application you requested does not exist.'},
    'node not found': {msg: 'The node you requested does not exist.'},
    'connection error': {msg: 'The cluster is not connected.', action: 'Review the configuration', to: {name: 'workspace_settings'}},
};

export default {
    data() {
        return {
            context: this.$api.context,
        };
    },

    watch: {
        $route: {
            handler: function () {
                this.redirect();
            },
            immediate: true,
        }
    },

    computed: {
        status() {
            return this.context.status || '';
        },
        error() {
            if (!this.status) {
                return null;
            }
            return errors[this.status] || {msg: this.status};
        },
    },

    methods: {
        redirect() {
            if (this.$route.name === 'project') {
                this.$router.replace({name: 'overview'}).catch(err => err);
            }
        },
    },
}
</script>

<style scoped>

</style>
